import React from "react";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import { ArrowLeft } from "react-feather";
import { DownloadIcon, FilterIcon } from "../Icon/Icon";
import { InputText } from "../Input/Input";
import Button from "../ButtonDefault/Button";
import Tooltip from "../Tooltip/Tooltip";

const Container = styled.div`
	display: flex;
	justify-content: space-between;
	margin-bottom: 15px;
	width: 100%;
`;

const LeftPanel = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	width: 50%;
	color: ${props => props.theme.primary_one};
	position: relative;

	&:after{
		content: "";
		display: block;
		width: 50px;
		height: 2px;
		background: ${props => props.theme.primary_one};
		position: absolute;
		bottom: -4px;
		left: 0;
	}

	&.card-title{
		&:after{
			width: 2px;
			height: 30px;
			bottom: 0px;
		}
	}
`;

const RightPanel = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	width: 50%;
`;

const HeaderButton = styled(Button)`
	margin-left: 15px;
	text-align: center;
	line-height: 50%;
	position: relative;
	margin-bottom: 5px;
	justify-content: center;
	&:hover ${Tooltip} {
		visibility: visible;
	}
`;

const HeaderButtonG = styled(Button)`
	margin-left: 15px;
	text-align: center;
	line-height: 50%;
	position: relative;
	margin-bottom: 5px;
	justify-content: center;
	&:hover ${Tooltip} {
		visibility: visible;
	}
	background-color: #79ec7d;
	:hover {
		background-color: #6ed371;
	}
`;

const Title = styled.div`
	font-family: Jost;
	font-style: normal;
	font-weight: bold;
	font-size: 1.4rem;
	line-height: 30px;
	align-self: center;
	color: ${props => props.theme.primary_one};
	margin-left: 8px;
`;

const Return = styled(ArrowLeft)`
	color: #888888;
	margin-right: 10px;

	:hover {
		cursor: pointer;
		color: #626262;
	}
`;

const Search = styled(InputText)`
	width: 50%;
	margin: 5px 5px 0px 5px;
`;

function Header(props) {
	const { icon: Icon } = props;

	const handleReturnButton = () => {
		props.history.goBack();
	};

	return (
		<Container>
			<LeftPanel className={props.classNameTitle}>
				{props.showReturnButton && (
					<Return onClick={handleReturnButton} />
				)}
				{props.icon && <Icon />}
				<Title>{props.title}</Title>
			</LeftPanel>

			<RightPanel>
				{props.showSearchButton && (
					<Search
						type="text"
						id="search"
						placeholder="Buscar"
						defaultValue={""}
					/>
				)}
				{props.showDownloadButton && (
					<Button
						type="button"
						title="Fazer download"
						variant="outlined"
						onClick={props.handleDownloadButtonClick}
					>
						<DownloadIcon />
					</Button>
				)}
				{props.showNewRegisterButton && (
					<HeaderButton
						type="button"
						variant="outlined"
						onClick={props.handleNewRegisterButtonClick}
					>
						Cadastrar
					</HeaderButton>
				)}
				{props.showFilterButton && (
					<Button
						type="button"
						title="Abrir filtro"
						onClick={props.handleFilterButtonClick}
					>
						<FilterIcon />
					</Button>
				)}
			</RightPanel>
		</Container>
	);
}

export default withRouter(Header);
